import React, { useEffect, useState } from 'react'
import AxiosInstance from '../../../Helper/AxiosInstance'
import { showDate } from '../../../Helper/Functions'
import { C, fBody } from '../../../Shared/Brand'
import { PageHeader, StatRow, StatCard, TableWrap, EmptyState } from '../../../Shared/DashboardUI'

export default function SubscriptionsDetails() {
   const [data, setData] = useState([])

   const fetchData = async () => {
      try {
         const response = await AxiosInstance.get('/report?type=topup');
         if (response.status === 1) { setData(response.data) }
      } catch (err) { }
   }
   useEffect(() => { fetchData() }, [])
   return (
      <>
         <PageHeader
            title="Your Subscriptions"
            action={<a className="xdb-btn" href="#!" style={{ textDecoration: 'none' }} data-bs-toggle="modal" data-bs-target="#buypack">Buy Package</a>}
         />
         <StatRow>
            <StatCard label="Total Arbitrage Profit" value="$0.00" icon="ri-line-chart-line" />
            <StatCard label="Total Active Subscriptions" value={data?.reduce((total, _) => total + 1, 0)} icon="ri-checkbox-circle-line" />
            <StatCard label="Total Flushed Subscriptions" value="0" icon="ri-close-circle-line" />
            <StatCard label="Subscriptions in Queue" value="0" icon="ri-time-line" />
         </StatRow>
         <div className="xdb-card">
            <h5 style={{ fontSize: '14px', fontWeight: 700, color: C.ltx, marginTop: 0, marginBottom: '12px', fontFamily: fBody }}>Subscriptions</h5>
            <TableWrap>
               <thead>
                  <tr>
                     <th>#</th><th>Buy Date</th><th>Package ID</th><th>Subscription</th>
                     <th>Status</th><th>Earnings</th><th>Last Updated</th>
                  </tr>
               </thead>
               <tbody>
                  {(data || []).length === 0 ? (
                     <tr><td colSpan="7"><EmptyState /></td></tr>
                  ) : data.map((tr, ind) => (
                     <tr key={tr.id || ind}>
                        <td>{Number(ind + 1).toString().padStart(2, '0')}</td>
                        <td>{showDate(tr.ActiveDate, 'd d m y')} <span style={{ color: C.ltx3 }}>{showDate(tr.ActiveDate, 'h:m:sa')}</span></td>
                        <td>{tr.id}</td>
                        <td style={{ color: C.primary }}>USDT{tr.TransactionAmount}</td>
                        <td style={{ color: C.up }}>Active</td>
                        <td>
                           <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <span style={{ color: C.up, fontSize: '12px' }}>40.1%</span>
                              <div style={{ flex: 1, height: '6px', background: 'rgba(255,255,255,0.06)', borderRadius: '999px', overflow: 'hidden' }}>
                                 <div style={{ width: '0%', height: '100%', background: C.primary }} />
                              </div>
                              <span style={{ color: C.ltx3, fontSize: '12px', whiteSpace: 'nowrap' }}>${tr.TotalIncome} / ${tr.TransactionAmount * 2}</span>
                           </div>
                        </td>
                        <td>{showDate(tr.ActiveDate, 'd d m y')} <span style={{ color: C.ltx3 }}>{showDate(tr.ActiveDate, 'h:m:sa')}</span></td>
                     </tr>
                  ))}
               </tbody>
            </TableWrap>
         </div>
      </>
   )
}
